var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenantViolation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.186,
    height: 23.848,
    viewBox: "0 0 27.186 23.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2682803_attention_erro_exclamation_mark_warn_icon",
    "data-name": "2682803_attention_erro_exclamation_mark_warn_icon",
    transform: "translate(-6.557 -10.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M19.167,11.018,6.708,32.6a1.138,1.138,0,0,0,.983,1.7H32.609a1.138,1.138,0,0,0,.983-1.7L21.133,11.018a1.138,1.138,0,0,0-1.966,0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M29,36.844a1.6,1.6,0,1,1,1.6,1.6,1.539,1.539,0,0,1-1.6-1.6Zm.582-2.49-.406-8.014h2.81l-.39,8.014Z",
    transform: "translate(-10.451 -7.399)",
    fill: "#151517"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantViolation);
export default __webpack_public_path__ + "static/media/tenant_violation.2578ee7ec9371cafa50cbc8fdeed9cee.svg";
export { ForwardRef as ReactComponent };